/*Package importing*/
import React, { useState } from 'react';

/*Import custom components and assets*/
import H1 from '../../components/heading/h1';
import service from '../../services/service';

const OTPWidgetForgotPassword = (props) => {
    const [mobile] = useState(props.data);
    const [loading, setLoading] = useState(false);
    const [otp, setOtp] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const verifyOTPClick = async () => {
        setLoading(true);
        if (!otp) {
            setErrorMessage("Enter a valid otp.");
            setLoading(false);
            return false;
        }
        // call api
        var params = {
            mobile: mobile,
            otp: otp
        };
        var token = null;
        var response = await service(false, "admin/auth/verify-password-otp", params, token, false);
        if (response.status) {
            setLoading(false);
            props.verifyOTPSuccess(response);
        } else {
            setLoading(false);
            setErrorMessage(response.message);
        }
    };

    return (
        <div className="e-auth-widget-wrap">
            <H1 headOne="Enter" headTwo="OTP." />
            <dd className="e-input-contentbox mb-5">
                <input
                    id="uOTP"
                    value={otp}
                    onChange={(event) => { 
                        setOtp(event.target.value);
                        setErrorMessage("");
                    }}
                    type="text"
                    required
                    onKeyDown={(e) => e.keyCode === 13 && verifyOTPClick()} />
                <label htmlFor="uOTP">One Time Password</label>
            </dd>
            <div className="col-lg-12 e-error-red">
                {
                    errorMessage
                }
            </div>
           
            <div className={`col-12 p-0 mt-4 ${loading === true ? "e-auth-loader" : ""}`}>
                <span className="e-p-btn e-auth-btn" onClick={verifyOTPClick}>
                    <div>Submit</div>
                </span>
            </div>
        </div>
    );
};

export default OTPWidgetForgotPassword;